import React from 'react';

const wallets = [
  {
    name: "Ledger Nano X",
    type: "Hardware Wallet",
    pros: [
      "Military-grade offline security, ensuring your assets are safe from online threats",
      "Supports 5,500+ coins and tokens, including Ethereum, Bitcoin, and many altcoins",
      "Bluetooth-enabled for mobile use without compromising security",
      "Backed by a solid reputation in the crypto space for over a decade"
    ],
    bestFor: "Long-term holders, high-value portfolios, and those prioritizing offline security",
    link: "https://www.ledger.com/", // Replace with your affiliate URL
    bonus: "Free shipping + bonus accessories (limited-time offer)"
  },
  {
    name: "MetaMask",
    type: "Browser & Mobile Wallet",
    pros: [
      "Seamless integration with decentralized finance (DeFi) platforms and DApps",
      "Supports Ethereum, ERC-20 tokens, and all EVM-compatible networks like Binance Smart Chain",
      "Non-custodial wallet, meaning you have full control over your private keys",
      "Ideal for DeFi traders, NFT collectors, and those involved in Web3"
    ],
    bestFor: "DeFi users, NFT collectors, and DApp enthusiasts who want full control over their assets",
    link: "https://www.metamask.io/",
    bonus: "Free to use with open-source code — join a trusted community of millions of users"
  },
  {
    name: "Trust Wallet",
    type: "Mobile Wallet",
    pros: [
      "Supports 60+ blockchains and thousands of tokens, from Bitcoin to ERC-20 and BEP-20 tokens",
      "Integrated DEX (Decentralized Exchange) for direct token swaps without leaving the app",
      "Built-in staking features for earning passive income on your crypto holdings",
      "Simple, user-friendly design with secure encryption and private key management"
    ],
    bestFor: "Everyday traders, mobile-first investors, and those looking to earn passive income through staking",
    link: "https://www.trustwallet.com",
    bonus: "Earn staking rewards on select assets directly from the app"
  }
];

const WalletCard = ({ name, type, pros, bestFor, link, bonus }) => (
  <div style={styles.card}>
    <h3 style={styles.cardTitle}>{name} <span style={styles.type}>({type})</span></h3>
    <ul style={styles.list}>
      {pros.map((pro, idx) => (
        <li key={idx} style={styles.listItem}>✅ {pro}</li>
      ))}
    </ul>
    <p style={styles.bestFor}><strong>Best for:</strong> {bestFor}</p>
    <p style={styles.bonus}><strong>Bonus:</strong> {bonus}</p>
    <a href={link} style={styles.cta}>Get {name}</a>
  </div>
);

const CryptoWallets2025 = () => {
  return (
    <div style={styles.container}>
      <p style={styles.intro}>
        If you’re holding crypto in 2025 and still relying on exchange wallets, you’re exposing yourself to unnecessary risks.
        These top 3 wallets are trusted by millions of crypto investors for their unmatched security, ease of use, and flexibility.
        Whether you're a long-term holder, DeFi enthusiast, or NFT collector, there’s a wallet here to help you secure and grow your assets.
      </p>

      {wallets.map((wallet, index) => (
        <WalletCard key={index} {...wallet} />
      ))}

      <div style={styles.footer}>
        <h2>🔒 Why Wallets Matter More Than Ever in 2025</h2>
        <p>
          With increasing cyberattacks, exchange hacks, and tighter regulations, **self-custody** is no longer optional—it’s essential.
          These wallets offer high-end security, complete control over your private keys, and full compatibility with the latest crypto trends like DeFi and NFTs.
        </p>
        <p>
          Don’t let your assets be vulnerable. Choose the right wallet for your needs and ensure your crypto is safe, whether you're trading daily or holding for the long term.
        </p>

        <a href="#" style={styles.cta}>👉 Compare All Wallets & Choose the Best One for You</a>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '900px',
    margin: '0 auto',
    padding: '20px',
    fontFamily: 'Arial, sans-serif',
    lineHeight: '1.6',
    backgroundColor: '#f7f7f7',
    borderRadius: '10px',
    boxShadow: '0 8px 20px rgba(0, 0, 0, 0.1)',
  },
  intro: {
    fontSize: '18px',
    marginBottom: '30px',
    color: '#333',
    textAlign: 'center',
  },
  card: {
    border: '1px solid #ddd',
    borderRadius: '10px',
    padding: '20px',
    marginBottom: '25px',
    backgroundColor: '#fff',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.3s, box-shadow 0.3s',
  },
  cardTitle: {
    fontSize: '22px',
    marginBottom: '10px',
    color: '#2c3e50',
  },
  type: {
    fontSize: '14px',
    fontWeight: 'normal',
    color: '#7f8c8d',
  },
  list: {
    paddingLeft: '20px',
    marginBottom: '10px',
    color: '#34495e',
    listStyleType: 'none' 
  },
  listItem: {
    marginBottom: '8px',
  },
  bestFor: {
    marginBottom: '12px',
    fontSize: '16px',
    color: '#2980b9',
  },
  bonus: {
    marginBottom: '12px',
    fontSize: '16px',
    color: '#27ae60',
  },
  cta: {
    display: 'inline-block',
    marginTop: '12px',
    backgroundColor: '#0070f3',
    color: '#fff',
    padding: '12px 25px',
    textDecoration: 'none',
    borderRadius: '5px',
    fontSize: '16px',
    fontWeight: 'bold',
    textAlign: 'center',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  },
  ctaHover: {
    backgroundColor: '#005bb5',
    textDecoration: 'none',
  },
  footer: {
    marginTop: '40px',
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
  }
};

// Hover effect for CTA button
const handleCTAHover = (e) => {
  e.target.style.backgroundColor = '#005bb5';
};

const handleCTAUnhover = (e) => {
  e.target.style.backgroundColor = '#0070f3';
};

export default CryptoWallets2025;
